<script setup>
import { reactiveOmit } from '@vueuse/core';
import { RangeCalendarCell, useForwardProps } from 'reka-ui';
import { cn } from '@/lib/utils';

const props = defineProps({
    date: { type: null, required: true },
    asChild: { type: Boolean, required: false },
    as: { type: null, required: false },
    class: { type: null, required: false },
});

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <RangeCalendarCell
        :class="
            cn(
                '[&:has([data-selection-end])]:!rounded-r-0 first:[&:has([data-selected])]:rounded-l-0 last:[&:has([data-selected])]:rounded-r-0 [&:has([data-selected][data-selection-end])]:rounded-r-0 [&:has([data-selected][data-selection-start])]:rounded-l-0 relative p-0 text-center text-sm focus-within:relative focus-within:z-20 [&:has([data-selected])]:bg-accent [&:has([data-selected])]:text-white [&:has([data-selected][data-outside-view])]:bg-accent/50 [&:has([data-selection-end])]:!rounded-r-full [&:has([data-selection-start])]:!rounded-l-full',
                props.class,
            )
        "
        v-bind="forwardedProps"
    >
        <slot />
    </RangeCalendarCell>
</template>
